module.exports = {
  labels: {
    zh: [
      '廚藝管理',
      '旅遊企業管理',
      '文化遺產管理',
      '酒店管理',
      '酒店管理(夜間)',
      '旅遊會展及節目管理',
      '旅遊會展及節目管理 (夜間)',
      '旅遊零售及巿場推廣管理',
    ],
    en: [
      'Culinary Arts Management',
      'Tourism Business Management',
      'Heritage Management',
      'Hotel Management',
      'Hotel Management (evening)',
      'Tourism Event Management',
      'Tourism Event Management (evening)',
      'Tourism Retail and Marketing Management',
    ],
  },
  series: [6, 18, 7, 29, 8, 18, 7, 7],
}
